<template>
    <v-card class="pa-4">
        <v-card-title class="headline px-0 mb-2">New Account</v-card-title>
        <v-form ref="form">
            <v-layout row>
                <v-flex xs6 column class="pr-3">
                    <v-text-field
                        autocomplete="new-password"
                        label="First Name"
                        v-model="account.firstName"
                        ref="firstName"
                        :rules="required"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Last Name"
                        v-model="account.lastName"
                        ref="lastName"
                        :rules="required"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="First Name Hebrew"
                        v-model="account.firstNameH"
                        ref="firstNameH"
                        :rules="required"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Last Name Hebrew"
                        v-model="account.lastNameH"
                        ref="lastNameH"
                        :rules="required"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Home Phone"
                        v-model="account.homePhone"
                        mask="###-###-####"
                        ref="homePhone"
                        :rules="required"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Cell Phone"
                        v-model="account.cellPhone"
                        mask="###-###-####"
                        ref="cellPhone"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6 column class="pl-3">
                    <v-text-field
                        autocomplete="new-password"
                        label="Address"
                        v-model="account.address"
                        ref="address"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="City"
                        v-model="account.city"
                        ref="city"
                    ></v-text-field>
                    <v-autocomplete
                        autocomplete="new-password"
                        label="State"
                        v-model="account.state"
                        ref="state"
                        :items="states"
                    ></v-autocomplete>
                    <v-text-field
                        autocomplete="new-password"
                        label="ZipCode"
                        v-model="account.zipcode"
                        ref="zipcode"
                        type="number"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Email"
                        v-model="account.emailAddress"
                        ref="emailAddress"
                        :rules="emailRules"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Father"
                        v-model="account.father"
                        ref="father"
                    ></v-text-field>
                    <v-text-field
                        autocomplete="new-password"
                        label="Father In Law"
                        v-model="account.fatherInLaw"
                        ref="fatherInLaw"
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-card-actions class="mr-0 mt-2">
            <v-spacer></v-spacer>
            <v-btn dark color="default" @click="closeNewAccountModal"
                >Cancel</v-btn
            >
            <v-btn color="success" @click="save">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    props: {
        closeNewAccountModal: Function,
        onCreated: Function,
    },
    data() {
        return {
            account: {
                accountID: "",
                firstName: "",
                lastName: "",
                firstNameH: "",
                lastNameH: "",
                homePhone: "",
                cellPhone: "",
                address: "",
                city: "Brooklyn",
                state: "NY",
                zipcode: "",
                emailAddress: "",
                father: "",
                fatherInLaw: "",
            },

            processing: false,

            states: ["NY", "NJ"],

            emailRules: [
                (v) => !v || /.+@.+/.test(v) || "E-mail must be valid",
            ],
            required: [(value) => !!value || "Required."],
        };
    },
    async created() {},
    computed: {},
    methods: {
        prefill(account) {
            this.account.accountID = account.accountID;
            this.account.firstName = account.firstName;
            this.account.lastName = account.lastName;
            this.account.firstNameH = account.firstNameH;
            this.account.lastNameH = account.lastNameH;
            this.account.homePhone = account.homePhone;
            this.account.cellPhone = account.cellPhone;
            this.account.address = account.address;
            this.account.city = account.city;
            this.account.state = account.state;
            this.account.zipcode = account.zipcode;
            this.account.emailAddress = account.emailAddress;
            this.account.father = account.father;
            this.account.fatherInLaw = account.fatherInLaw;
        },
        clear() {
            this.account.firstName = "";
            this.account.lastName = "";
            this.account.firstNameH = "";
            this.account.lastNameH = "";
            this.account.homePhone = "";
            this.account.cellPhone = "";
            this.account.address = "";
            this.account.city = "Brooklyn";
            this.account.state = "NY";
            this.account.zipcode = "";
            this.account.emailAddress = "";
            this.account.father = "";
            this.account.fatherInLaw = "";
        },
        async save() {
            if (!this.$refs.form.validate(true)) return;

            this.processing = true;

            try {
                const account = await this.$http.post(
                    "api/lapidusDayCamp/saveNewAccount?user=" +
                        this.$store.state.authentication.user +
                        "&prefix=XGC",
                    this.account
                );

                this.onCreated(account);

                this.closeNewAccountModal();

                this.clear();

                this.processing = false;
            } catch (e) {
                this.processing = false;

                return;
            }
        },
    },
};
</script>
